<template lang="html">
  <Col style="background: rgb(44, 56, 73); color: #fff; padding: 15vh 5vw;"  id="security">
    <Row type="flex" justify="space-around" align="middle" style="text-align: center;">
      <h1 class="title">Security and Privacy, Prioritized.</h1>
    </Row>
    <Row type="flex" justify="space-around" align="middle" style="text-align: center;">
      <p>Developed by financial technology experts using the industry's best security practices.</p>
    </Row>
    <Row type="flex" style="background: rgb(44, 56, 73); color: #fff; padding: 10vh 5vw;" justify="space-around">
      <Col style="width: 300px">
        <p>Our team has developed highly-available and secure software for nation-wide financial institutions to manage billions of US Dollars.</p>
      </Col>
      <Col style="margin: 42px">
        <Icon type="android-lock" size="52"></Icon>
      </Col>
      <Col style="width: 300px">
        <p><Icon type="ios-checkmark-outline" class="green"></Icon> <strong>256-Bit</strong> encryption at rest</p>
        <p><Icon type="ios-checkmark-outline" class="green"></Icon> <strong>256-Bit</strong> encrypted traffic</p>
        <p><Icon type="ios-checkmark-outline" class="green"></Icon> Company policies <strong>prioritizing security</strong></p>
      </Col>
    </Row>
  </Col>
</template>
<script>
export default {

};
</script>
<style lang="css" scoped>
  p { font-size: 16px; }
  .title { font-size: 28px; }
  .sub-title { font-size: 20px; }
</style>


// WEBPACK FOOTER //
// src/components/SecuritySection.vue